import type { FC } from 'react';
import { lazy, Suspense } from 'react';

import { useIsMobile } from '../../../hooks';
import { SkeletonMainCategoriesDesktop, SkeletonMainCategoriesMobile } from '../../Skeleton';

const LazyGeneratedBurgerMainMenuLinks = lazy(async () => import('./Links'));

export const BurgerMenuLinks: FC = () => {
  const isMobile = useIsMobile();

  return (
    <Suspense fallback={isMobile ? <SkeletonMainCategoriesMobile /> : <SkeletonMainCategoriesDesktop />}>
      <LazyGeneratedBurgerMainMenuLinks />
    </Suspense>
  );
};

export default BurgerMenuLinks;
